import config from 'config'
import lang from '@/lang'

const urlDefs = {
  single: 'trackedTime',
  multiple: 'trackedTimes',
}

const resourceUrl = `${config.resourceHost}${urlDefs.single}`
const resourcesUrl = `${config.resourceHost}${urlDefs.multiple}`

export const urls = {
  list: resourcesUrl,
  single: resourceUrl,
  billing: `${resourceUrl}/customer/`,
}

export default {
  resourceUrl,
  requestUrl: urls,

  timeTrackingListSetting: `${config.resourceHost}setting/userlist/trackedTime`,

  routes: {
    list: `${resourcesUrl}`,
  },

  clientUrl: {
    billing: '/timetracking/billing/customer/',
    multiple: '/timetrackings',
    single: 'timetracking',
    edit: '/timetracking/edit/',
  },

  options: {
    list: {
      name: urlDefs.single,
      pagination: {
        page: 1,
        pageSize: 20,
      },
      quickfilters: {
        models: [
          {
            name: 'default',
            title: 'Offen',
            filter: '',
          },
          {
            name: 'invoiced',
            title: 'Abgerechnet',
            filter: 'invoiced',
          },
        ],
      },
      defaultSort: {
        property: 'customerName',
        desc: false,
      },
    },
    billing: {
      pagination: {
        page: 1,
        pageSize: -1,
      },
      defaultSort: {
        property: 'startDate',
        desc: true,
      },
    },
  },
  filters: [
    {
      name: 'all',
      title: lang.label.allCapital,
      quickFilter: null,
    },
    {
      name: 'duration',
      title: lang.label.duration,
      quickFilter: null,
    },
  ],
}
